<template>
  <tr>
    <td v-if="column_dict['status']">
      <span class="badge"
        :class="{
          'badge-green': model.status.isActive(),
          'badge-grey': !model.status.isActive()
        }"
      >
        {{ model.status.frontend_name }}
      </span>
    </td>
    <td v-if="column_dict['license_plate']">
      <span
        class="license"
        :class="model.country ? model.country.iso_3166_2 : 'nl'"
      >
        {{ model.license_plate_formatted }}
      </span>
    </td>
    <td v-if="column_dict['group']">{{ model.group.name }}</td>
    <td v-if="column_dict['segment']">{{ model.segment.name }}</td>
    <td v-if="column_dict['brand']">{{ model.model.brand.name }}</td>
    <td v-if="column_dict['model']">{{ model.model.name }}</td>
    <td v-if="column_dict['transmission_type']">
      {{ model.transmission_type.name }}
    </td>
    <td v-if="column_dict['fuel_type']">{{ model.fuel_type.name }}</td>
    <td v-if="column_dict['depot']">{{ model.depot.name }}</td>
    <td v-if="column_dict['client']">{{ model.client.company.name }}</td>
  </tr>
</template>

<script>
import VehicleService from "@/services/VehicleService";
import modelListItemMixin from "@/components/crud/mixins/model-list-item.mixin";
import { mapGetters } from "vuex";

const vehicleService = new VehicleService();

export default {
  name: "vehicle-row",
  props: ["column_dict"],
  mixins: [modelListItemMixin],
  mounted() {
    console.log(this.model);
  },
  components: {},
  methods: {}
};
</script>
